import RoutesChangementResponsableLegalReinitialisation from './reinitialisation/routes';
import { initSubRoutes } from '../../../utils/router';

const RoutesChangementResponsableLegal = initSubRoutes({
    route: '/changement-responsable-legal',
    subroutes: {
        reinitialisation: RoutesChangementResponsableLegalReinitialisation,
    },
    nom: 'Changement de responsable légal',
});

export default RoutesChangementResponsableLegal;
